import { makeStyles, Spinner } from "@fluentui/react-components";
import * as React from "react";

const useStyles = makeStyles({
  spinner: {
    display: "flex",
    margin: "auto",
    height: "100vh",
    alignItems: "center",
    justifyContent: "center",
  },
});

const LoadingScreen: React.FC = () => {
  const styles = useStyles();
  return (
    <div className={styles.spinner}>
      <Spinner size={"large"} label="Lade Associate..." />
    </div>
  );
};

export default LoadingScreen;
